import script from "./NavSites.vue?vue&type=script&setup=true&lang=js"
export * from "./NavSites.vue?vue&type=script&setup=true&lang=js"

import "./NavSites.vue?vue&type=style&index=0&id=12a3f42a&lang=css"

const __exports__ = script;

export default __exports__